import { render, staticRenderFns } from "./throughRecords.vue?vue&type=template&id=c78d92b2&scoped=true"
import script from "./throughRecords.vue?vue&type=script&lang=js"
export * from "./throughRecords.vue?vue&type=script&lang=js"
import style0 from "./throughRecords.vue?vue&type=style&index=0&id=c78d92b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78d92b2",
  null
  
)

export default component.exports